import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import loadable from "@loadable/component";
import withWishlist from "../with-wishlist";
import withLogin from "../with-login";
const Login = loadable(() => import("../login"));
const PreApprovalOnFlyModal = loadable(() => import("../pre-approval-on-fly-modal"), { ssr: false });
const SecondaryIdentifierModal = loadable(() => import("../../shared/secondary-identifier-modal"), { ssr: false });

const DesktopRoot = ({
    children,
    onLoginSuccessCallback,
    setOnLoginSuccessCallback,
    onLoginCloseCallback,
    setOnLoginCloseCallback,
    isLoginPopupVisible,
    isPreApprovalModalOpen,
    isSecondaryIdentifierModalVisible,
    // isSSR,
    // reloadCarListConnect,
    isSSR,
    reloadCarListConnect,
    isLoggedIn,
    secureToken,
    fetchWishlistedCarsListConnect
}) => {
    const [hasBadUserSession, setHasBadUserSession] = useState(false);

    useEffect(() => {
        if (window.sessionStorage.getItem("paof_bad_user") === "true") {
            setHasBadUserSession(true);
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn && secureToken) {
            fetchWishlistedCarsListConnect(secureToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (!isSSR) {
            reloadCarListConnect(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            { children }
            {isLoginPopupVisible && <Login
                onLoginSuccessCallback={onLoginSuccessCallback}
                setOnLoginSuccessCallback={setOnLoginSuccessCallback}
                onLoginCloseCallback={onLoginCloseCallback}
                setOnLoginCloseCallback={setOnLoginCloseCallback}
            />}
            {(isPreApprovalModalOpen || hasBadUserSession) && <PreApprovalOnFlyModal />}
            {isSecondaryIdentifierModalVisible && <SecondaryIdentifierModal />}
        </React.Fragment>
    );
};

DesktopRoot.propTypes = {
    children: PropTypes.object,
    onLoginSuccessCallback: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    onLoginCloseCallback: PropTypes.func,
    setOnLoginCloseCallback: PropTypes.func,
    isLoginPopupVisible: PropTypes.bool,
    isPreApprovalModalOpen: PropTypes.bool,
    isSecondaryIdentifierModalVisible: PropTypes.bool,
    isSSR: PropTypes.bool,
    reloadCarListConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchWishlistedCarsListConnect: PropTypes.func
};

export default withLogin(withWishlist(DesktopRoot));
